import '../styling/_curve.scss';

function Curve(props) {
  return (
    <div className="curve">
            <div className="wave" alt='curve'  />
    </div>
  );
}

export default Curve;
